import { createContext } from 'react';
export const ShippingPendingContext = createContext(null);
